import { PropertyAPI } from "../../axios";

export const actions = {
  //Requisition Supply
  GetRequisitionAvailableByDu(context, data) {
    return PropertyAPI.get(`Requisition/Available/${data}`);
  },
  GetRequisitionDraftByDu(context, data) {
    return PropertyAPI.get(`Requisition/My/Draft/${data}`);
  },
  GetRequisitionPendingByDu(context, data) {
    return PropertyAPI.get(`Requisition/Pending/DeliveryUnit/${data}`);
  },
  GetRequisitionCompletedByDu(context, data) {
    return PropertyAPI.get(`Requisition/Completed/DeliveryUnit/${data}`);
  },
  GetRequisitionAvailable(context, data) {
    return PropertyAPI.get(`Requisition/Available/Campus/${data}`);
  },
  GetSimpleReqAvailable(context, data) {
    return PropertyAPI.get(`Requisition/Available/Simple/Campus/${data}`);
  },
  GetRequisitionPending(context, data) {
    return PropertyAPI.get(`Requisition/Pending/${data}`);
  },
  GetRequisitionPendingSumarry(context, data) {
    return PropertyAPI.get(`Requisition/Pending/Summary/${data}`);
  }, 
  GetRequisitionApproved(context, data) {
    return PropertyAPI.get(`Requisition/Approved/${data}`);
  },
  GetRequisitionApprovedSumarry(context, data) {
    return PropertyAPI.get(`Requisition/Approved/Summary/${data}`);
  }, 
  GetRequisitionCompleted(context, data) {
    return PropertyAPI.get(`Requisition/Completed/${data}`);
  },
  GetRequisitionCompletedSumarry(context, data) {
    return PropertyAPI.get(`Requisition/Completed/Summary/${data}`);
  }, 
  GetRequisitionSingle(context, data) {
    return PropertyAPI.get(`Requisition/Available/${data}`);
  },
  CreateRequisition(context, data) {
    return PropertyAPI.post(`Requisition/Create/${data.campusId}/${data.deliveryUnitId}`, data);
  },
  PostRequisition(context, data) {
    return PropertyAPI.post(`Requisition/Post/${data}`);
  },
  ApproveRequisition(context, data) {
    return PropertyAPI.put(`Requisition/Approve/${data}`);
  },
  UnApproveRequisition(context, data) {
    return PropertyAPI.put(`Requisition/UnApprove/${data}`);
  },
  DeleteRequisition(context, data) {
    return PropertyAPI.delete(`Requisition/${data}`);
  },
  UpdateRequisitionNumber(context, data) {
    return PropertyAPI.put(
      `Requisition/UpdateRequisitionNumber/${data.id}/${data.requisitionNumber}`
    );
  },

  //Requisition Stock
  GetStockRequisitionPending(context, data) {
    return PropertyAPI.get(`Requisition/Stocks/Pending/${data}`);
  },
  GetStockRequisitionApproved(context, data) {
    return PropertyAPI.get(`Requisition/Stocks/Approved/${data}`);
  },
  GetStockRequisitionCompleted(context, data) {
    return PropertyAPI.get(`Requisition/Stocks/Completed/${data}`);
  },

  //Requisition Item
  GetRequisitionItem(context, data) {
    return PropertyAPI.get(`RequisitionItem/Items/${data}`);
  },
  GetRequisitionItemSummary(context, data) {
    return PropertyAPI.get(`RequisitionItem/Items/Summary/${data}`);
  },
  AddRequisitionItem(context, data) {
    return PropertyAPI.post(`RequisitionItem/Add`, data);
  },
  UpdateRequisitionItem(context, data) {
    return PropertyAPI.put(`RequisitionItem/Update/${data.id}`, data);
  },
  DeleteRequisitionItem(context, data) {
    return PropertyAPI.delete(`RequisitionItem/${data}`);
  },
  GenerateRequisitionNumber(context, data) {
    return PropertyAPI.get(`Requisition/GenerateRequisitionNumber/${data}`);
  }
};
